import { observer } from "mobx-react";
import React, { useContext } from "react";
import OrderSettingsPageStoreContext from "../context";
import { FormControl, Paper, Typography } from "../../../../../common/components/libs";
import { Checkbox, FormControlLabel, Input, InputLabel } from "@material-ui/core";
import { changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator, localize } from "../../../../../common/libs";
import { PaymentProviderType } from "../../../../../services/general/models";
import useCompanyEntityData from "../../../../../hooks/useCompanyEntityData";
import { useStores } from "../../../../../hooks";
import { useTranslation } from "react-i18next";


const PaymentSettingsBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);
    const { hasIIkoIntegration } = store;

    const { authStore } = useStores()
    const paymentSettings = store.paymentSettings;
    const [companyEntityData] =
        useCompanyEntityData(authStore.currentUser.organizationData.organizationBranchId);

    return <>
        <Typography variant={"h3"} mt={20} mb={2}>
            {t("menu:orderSettingsPage.paymentMethods")}
        </Typography>
        <Paper p={5} style={{ maxWidth: 800, width: "100%" }}>
            <FormControl>
                <FormControlLabel
                    value={PaymentProviderType.offline}
                    key="offline"
                    control={<Checkbox
                        checked={paymentSettings[PaymentProviderType.offline].isEnabled && authStore.isBasicFeaturesActive()}
                        onChange={(e) => {
                            if (!authStore.isBasicFeaturesActive()) {
                                store.openTariffPromptForm('Basic')
                            } else {
                                changeCheckboxEventHandlerDecorator(store.toggleOfflinePayment.bind(store))(e)
                            }
                        }}
                    />}
                    label={<>
                        <Typography variant={'h6'}>
                            {t("menu:orderSettingsPage.paymentByCashOrCard")}
                        </Typography>
                        <Typography variant={'body2'} color={'textSecondary'}>
                            {t("menu:orderSettingsPage.paymentToWaiterOrCourier")}
                        </Typography>
                    </>}
                />
                {
                    hasIIkoIntegration && <FormControl fullWidth>
                        <InputLabel htmlFor="name">ID способа оплаты</InputLabel>
                        <Input
                            value={store.paymentSettings[PaymentProviderType.offline].externalId}
                            onChange={changeEventHandlerDecorator(
                                (v: string) => {
                                    store.setExternalIdForOfflinePayment(v);
                                }
                            )}
                        />
                    </FormControl>
                }
                <br/>
                <FormControlLabel
                    key="cloudpayments"
                    value={PaymentProviderType.cloudpayments}
                    control={
                        <Checkbox
                            checked={paymentSettings[PaymentProviderType.cloudpayments].isEnabled && authStore.isAdvancedFeaturesActive()}
                            onChange={(e) => {
                                if (!authStore.isAdvancedFeaturesActive()) {
                                    store.openTariffPromptForm('Advanced')
                                } else {
                                    changeCheckboxEventHandlerDecorator(store.toggleOnlinePayment.bind(store))(e)
                                }
                            }}
                        />
                    }
                    label={
                        <>
                            <Typography variant={'h6'}>
                                {t("menu:orderSettingsPage.paymentThroughMenu")}
                                {!companyEntityData.isCompanyCardLocked && <Typography color={'error'}>
                                    {t("menu:orderSettingsPage.paymentInTestMode")}
                                </Typography>}
                            </Typography>
                            <Typography variant={'body2'} color={'textSecondary'}>
                                {t("menu:orderSettingsPage.paymentMadeViaInternet")}
                            </Typography>
                        </>
                    }
                />
                {
                    hasIIkoIntegration && <FormControl fullWidth>
                        <InputLabel htmlFor="name">ID способа оплаты</InputLabel>
                        <Input
                            value={store.paymentSettings[PaymentProviderType.cloudpayments].externalId}
                            onChange={changeEventHandlerDecorator(
                                (v: string) => {
                                    store.setExternalIdForOnlinePayment(v);
                                }
                            )}
                        />
                    </FormControl>
                }

                <br/>

                <FormControlLabel
                    key="sbpTochka"
                    value={PaymentProviderType.sbpTochka}
                    control={
                        <Checkbox
                            checked={paymentSettings[PaymentProviderType.sbpTochka].isEnabled && authStore.isAdvancedFeaturesActive()}
                            onChange={(e) => {
                                if (!authStore.isAdvancedFeaturesActive()) {
                                    store.openTariffPromptForm('Advanced')
                                } else {
                                    changeCheckboxEventHandlerDecorator(store.toggleSBPTochkaPayment.bind(store))(e)
                                }
                            }}
                        />
                    }
                    label={
                        <>
                            <Typography variant={'h6'}>
                                {t("menu:orderSettingsPage.paymentThroughMenuSBP")}
                                {!companyEntityData.isCompanyCardLocked && <Typography color={'error'}>
                                    {t("menu:orderSettingsPage.paymentInTestMode")}
								</Typography>}
                            </Typography>
                            <Typography variant={'body2'} color={'textSecondary'}>
                                {t("menu:orderSettingsPage.paymentMadeViaSBPDescription")}
                            </Typography>
                        </>
                    }
                />
                {
                    hasIIkoIntegration && <FormControl fullWidth>
						<InputLabel htmlFor="name">ID способа оплаты</InputLabel>
						<Input
							value={store.paymentSettings[PaymentProviderType.sbpTochka].externalId}
							onChange={changeEventHandlerDecorator(
                                (v: string) => {
                                    store.setExternalIdForSBPTochkaPayment(v);
                                }
                            )}
						/>
					</FormControl>
                }
                {/* <FormControlLabel
                    key="toBankCard"
                    value={PaymentProviderType.toBankCard}
                    control={
                        <Checkbox
                            checked={paymentSettings[PaymentProviderType.toBankCard].isEnabled}
                            onChange={changeCheckboxEventHandlerDecorator(togglePaymentType(PaymentProviderType.toBankCard))}
                        />
                    }
                    label="Оплата переводом на банковскую карту"
                    disabled={true}
                />*/}
                <br/>
                {/*{!hasIIkoIntegration && <FormControlLabel*/}
                {/*    key="companyInvoice"*/}
                {/*    value={PaymentProviderType.companyInvoice}*/}
                {/*    control={*/}
                {/*        <Checkbox*/}
                {/*            checked={paymentSettings[PaymentProviderType.companyInvoice].isEnabled}*/}
                {/*            onChange={changeCheckboxEventHandlerDecorator(store.toggleByInvoicePayment.bind(store))}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    label={*/}
                {/*        <>*/}
                {/*            <Typography variant={'h6'}>*/}
                {/*                {t("menu:orderSettingsPage.paymentBasedOnInvoice")}*/}
                {/*            </Typography>*/}
                {/*            <Typography variant={'body2'} color={'textSecondary'}>*/}
                {/*                {t("menu:orderSettingsPage.buyerLeavesOrganizationData")}*/}
                {/*            </Typography>*/}
                {/*        </>*/}
                {/*    }*/}
                {/*    disabled={true}*/}
                {/*/>*/}
                {/*}*/}
            </FormControl>

        </Paper>
    </>

}


export default observer(PaymentSettingsBlock)
